/* Guides family pages (Stanton custom sofas, small apartments, affordable furniture, best furniture stores).
   Progressive enhancement only: chat links open the site chat in place (photo prompt where marked), and consent-gated
   GA4 events record CTA clicks, chat opens and FAQ opens. Every link works without this file. */
(() => {
  'use strict';
  if (window.wnfswGuideInit) return;
  window.wnfswGuideInit = true;
  const measurementId = 'G-0JE425EEKS';
  const NAMES = {
    'stanton': 'stanton_custom',
    'small-apartments': 'small_apartments',
    'affordable': 'affordable',
    'best-stores': 'best_stores'
  };
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const init = () => {
    const root = document.querySelector('[data-wnfsw-guides-page]');
    if (!root) return;
    const key = NAMES[root.dataset.wnfswGuidesPage] || 'guide';
    const track = (suffix, params = {}) => {
      if (!allowed() || typeof window.gtag !== 'function') return;
      window.gtag('event', `wnf_${key}_${suffix}`, { send_to: measurementId, page_location: location.origin + location.pathname, ...params });
    };
    // Capture phase, so this runs before Motion's link handler starts its page transition.
    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) return;
      const chat = event.target.closest('[data-wnfsw-chat]');
      if (chat && typeof window.WNFChatOpen === 'function') {
        // Motion binds a page-transition click handler on every link that ignores preventDefault; stop it reaching the link.
        event.preventDefault();
        event.stopPropagation();
        const intent = chat.dataset.wnfswChat;
        window.WNFChatOpen(intent ? { intent } : undefined);
        track('chat_open', { cta_placement: chat.dataset.wnfswCta || 'chat', chat_intent: intent || 'general' });
        return;
      }
      const cta = event.target.closest('[data-wnfsw-cta]');
      if (cta) track('cta_click', { cta_placement: cta.dataset.wnfswCta, link_url: cta.getAttribute('href') || '', transport_type: 'beacon' });
    }, true);
    root.querySelectorAll('details').forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open) track('faq_open', { question: (d.querySelector('summary')?.firstChild?.textContent || '').trim().slice(0, 90) });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
